import ShareAndroid from './ShareAndroid'

export default ShareAndroid
// eslint-disable-next-line import/export
export * from './ShareAndroid'
